<template>
    <!-- <dynamic-template :template="bespokeHome" v-if="bespokeHome !== undefined" /> -->

    <main id="mainContent" class="home" :class="fullHeight">
        <section class="home-new-section section-slant-right-bottom header-hero bg-color-secondary">
            <div class="circle-image" :style="{ backgroundImage: `url(${backgroundImage})` }"></div>

            <div class="container">
                <div class=" flex">
                    <div class="intro-left" :style="{ color: homepageOverrides.fontColour }">
                        <h1 :class="['primary-highlight', { small: homepageOverrides.h1IsSmall }]" :style="{ color: homepageOverrides.h1Colour }">Welcome to the
                            member website for {{ formatTheSchemeName }}</h1>
                        <div>
                            <div v-if="overrideHomepageTextHTML" v-html="overrideHomepageTextHTML"></div>
                            <p v-else>This website provides you with information about your benefits in the {{ clientConfig.fundOrScheme }}. It allows you to
                                update your details, view your correspondence and find other helpful resources.</p>
                            <div v-if="overrideHomepageCaveatTextHTML" v-html="overrideHomepageCaveatTextHTML"></div>
                            <p v-else>You will need to register to view your <template v-if="isWebsiteLevel2">information</template><template
                                    v-else>benefits</template>. There is a helpful video and step-by-step registration guide below to assist you with this.</p>
                        </div>
                        <div class="actions-wrapper" v-if="!isRegistrationAndLoginDisabled">
                            <button class="button-solid-rounded col-sm-12 col-lg-5" v-if="!isLoggedIn" @click="login">
                                Log in / register <span class="button-icon"><font-awesome-icon :icon="['fal', 'lock']"></font-awesome-icon></span>
                            </button>
                            <a class="button-solid-rounded col-sm-12 col-lg-5 offset-lg-1 text-center" v-if="!isLoggedIn" download target="_blank"
                                :href="`${$store.state.clientConfig.directoryUrl}/documents/step-by-step-registration-guide.pdf`">
                                Registration guide <span class="button-icon"><font-awesome-icon :icon="['fal', 'file-pdf']"></font-awesome-icon></span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="mt-5 hero-cards-container">
                    <div class="video-holder">
                        <div class="home-card-shadow video-holder-inner" v-if="clientConfig.homepageWidgets && clientConfig.homepageWidgets.length > 0">
                            <HomepageHeroVideo :widget="clientConfig.homepageWidgets" />
                        </div>
                    </div>
                    <div class="homepage-card" v-if="!isRegistrationAndLoginDisabled">
                        <div class="homepage-card--inner home-card-shadow">
                            <div class="card-icon">
                                <img src="/icons/piggy-bank.svg" alt="My Pension - piggy bank icon" />
                            </div>
                            <div class="text-content">
                                <h2>My Pension</h2>
                                <p v-if="isWebsiteLevel2">View and securely update your information together with access to your personal correspondence.</p>
                                <p v-else>View your benefits, access your personal correspondence and securely update your information.</p>
                            </div>
                            <div class="homepage-card-bottom">
                                <button class="button-solid-rounded" @click="$router.push('/my-pension/my-data')">
                                    My Pension <span class="button-icon"><font-awesome-icon :icon="['fal', 'lock']"></font-awesome-icon></span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="homepage-card">
                        <div class="homepage-card--inner home-card-shadow ">
                            <div class="card-icon">
                                <img src="/icons/coins-jar.svg" alt="About your fund - coins in a jar icon" />

                            </div>
                            <div class="text-content">
                                <h2>About your {{ clientConfig.fundOrScheme }}</h2>
                                <p>Find information about the {{ clientConfig.fundOrScheme }} and the latest communications from the
                                    {{ clientConfig.trusteeWording }}.</p>
                            </div>

                            <div class="homepage-card-bottom">
                                <button class="button-solid-rounded" @click="$router.push('/information')">
                                    Find out more <span class="button-icon"><font-awesome-icon :icon="['fal', 'arrow-right']"></font-awesome-icon></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <MyPension />
        <section v-if="!isRegistrationAndLoginDisabled" class="home-new-section help-topics bg-color-secondary section-slant-left-top section-slant-right-bottom">
            <HelpTopics :hiddenCategories="[isWebsiteLevel2 ? 'Video guides' : 'General']" />
        </section>
        <KeyInformation />
        <FooterBar />
    </main>
</template>
<script>
import auth from '@/services/authentication';
import HomepageHeroVideo from '@/components/widgets/HomepageHeroVideo.vue';
import MyPension from '@/components/newHomepage/MyPension.vue';
import HelpTopics from '@/components/newHomepage/HelpTopics.vue';
import KeyInformation from '@/components/newHomepage/KeyInformation.vue';
import FooterBar from '@/components/FooterBar.vue';
import { mapGetters } from 'vuex';


export default {
    name: 'home-new-style',
    created () {
        this.homepageCaveat = this.$store.getters['clientConfig/clientConfig'].homepageCaveat ? this.$store.getters['clientConfig/clientConfig'].homepageCaveat : '';
        this.modalText = this.homepageOverrides.modalTextOverride ? this.homepageOverrides.modalTextOverride : this.modalText;
    },
    components: {
        MyPension,
        HomepageHeroVideo,
        HelpTopics,
        KeyInformation,
        FooterBar,
    },
    computed: {
        ...mapGetters('clientConfig', [
            'formatTheSchemeName',
        ]),
        isWebsiteLevel2 () {
            return this.websiteLevel === 2;
        },
        websiteLevel () {
            return this.clientConfig.websiteLevel;
        },
        primary () {
            return 'rgb(0, 47, 95)';
        },
        clientConfig () {
            return this.$store.getters['clientConfig/clientConfig'];
        },
        isLoggedIn () {
            return this.$store.getters['auth/getAuthState'];
        },
        fullHeight () {
            return this.$store.state.ui.showFooter ? '' : 'full-home-height';
        },
        bespokeHome () {
            return this.$store.state.clientConfig.bespokeHome;
        },
        overrideHomepageTextHTML () {
            return this.$store.state.clientConfig.homepageText;
        },
        overrideHomepageCaveatTextHTML () {
            return this.$store.state.clientConfig.homepageCaveat;
        },
        homepageOverrides () {
            return this.clientConfig.homepage;
        },
        backgroundImage () {
            return this.homepageOverrides.backgroundImage ? `${this.clientConfig.directoryUrl}/img/${this.homepageOverrides.backgroundImage}` : '/img/homepage/homepage-bg.jpg';
        },
        showModal () {
            return this.$store.state.ui.showPopUp;
        },
        isRegistrationAndLoginDisabled () {
            return !!this.clientConfig.disableRegistrationAndLogin;
        },

    },

    methods: {
        closeModal () {
            this.$store.commit('updatePopUp', false);
        },
        login () {
            auth.init();
            this.$store.commit('analytics/setLoggingIn');
            auth.signInSignUp();
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/scss/_mixins.scss';

.actions-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.homepage-card {
    flex: 0 0 30%;
    box-sizing: border-box;

    &:not(:last-of-type) {
        padding-right: 1rem;
    }

    &--inner {
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 1rem;
        height: 100%;
        background-color: white;
        border-radius: 0.5rem;

        .card-icon {
            position: absolute;
            bottom: 20px;
            right: 5px;
            /* font-size: 6rem; */
            opacity: 0.05;
            width: 100px;
        }

        .text-content {
            flex-grow: 1;

            h2 {
                font-size: 1.5rem;
                margin-bottom: 1rem;
            }
        }
    }
}

.hero-cards-container {
    display: flex;

    @include responsive('md') {
        flex-wrap: wrap;
    }

    .homepage-card {
        @include responsive('md') {
            flex: 0 0 50%;
        }

        @include responsive('mdLandscape') {
            font-size: 0.8rem;
        }

        @include responsive('sm') {
            flex: 0 0 100%;
            padding-right: 0;

            &:not(:last-of-type) {
                margin-bottom: 2rem;
            }
        }

        @include browser('ie') {
            @include responsive('md') {
                flex: 100%;

                &:not(:last-of-type) {
                    margin-bottom: 2rem;
                }

                &:not(:last-of-type) {
                    padding-right: 1rem;
                }
            }
        }
    }
}

.video-holder {
    flex: 0 0 40%;
    padding-right: 1rem;

    @include responsive('md') {
        flex: 0 0 100%;
        padding-right: 0;
        margin-bottom: 2rem;
    }

    .video-holder-inner {
        border-radius: 0.5rem;
        overflow: hidden;
        height: 100%;
    }
}

%slanted-div {
    content: ' ';
    position: absolute;
    display: block;
    width: 100%;
    height: 10rem;
    background: #ffffff;
    z-index: -2;
}

.section-slant {
    position: relative;

    &-left-bottom {
        &::after {
            @extend %slanted-div;
            bottom: 0;
            transform-origin: left bottom;
            transform: skewY(4deg);
        }
    }

    &-right-bottom {
        &::after {
            @extend %slanted-div;
            bottom: -3rem;
            transform-origin: right bottom;
            transform: skewY(-4deg);
        }
    }

    &-left-top {
        &::before {
            @extend %slanted-div;
            top: -10rem;

            @include responsive('md') {
                top: -6rem;
            }

            @include responsive('mdLandscape') {
                top: -5rem;
            }

            @include responsive('sm') {
                top: -5rem;
            }

            z-index: -1;
            height: 10rem;
            background: $sectionColor1;
            transform-origin: left bottom;
            transform: skewY(4deg);
        }
    }

    &-right-top {
        &::before {
            @extend %slanted-div;
            top: 0;
            transform-origin: right bottom;
            transform: skewY(-4deg);
        }
    }
}

.bg-color-secondary {
    background-color: $sectionColor1;
}

//-----------///
.home {
    position: relative;
    top: $nav-height;
    left: 0;

    overflow-y: scroll;
    height: calc(var(--vh100) - $nav-height); // allow for nav & footer popup

    @include responsive('sm') {
        padding-bottom: 0px !important;
    }

    &.full-home-height {
        height: calc(var(--vh100) - $nav-height);
        transition: min-height 0.3s ease-in-out;
    }

    // Section 1 //
    .header-hero {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        overflow: hidden;
        box-sizing: border-box;
        background-color: #f5f5f5;
        padding-top: 3rem;
        padding-bottom: 3rem;

        @include responsive('md') {
            height: auto;
            padding-bottom: 3rem;
        }

        @include responsive('sm') {
            height: auto;
            padding-bottom: 3rem;
        }

        .circle-image {
            position: absolute;
            top: -12rem;
            right: -7rem;
            z-index: -1;
            width: 55rem;
            height: 55rem;
            border-radius: 50%;
            overflow: hidden;
            background-size: cover;
            background-position: right;

            @include responsive("sm") {
                display: none;
            }

            @include responsive('md') {
                top: -2.5rem;
                width: 30rem;
                height: 30rem;
            }

            @include responsive('xl') {
                top: -3rem;
                right: -10rem;
                width: 40rem;
                height: 40rem;
            }

            @include responsive('mdLandscape') {
                top: -2.5rem;
                right: -40%;
            }
        }

        .intro-left {
            width: 50%;

            @include responsive("xs") {
                width: 100%;
                padding-top: 0px;
            }

            @include responsive("md") {
                padding-top: 0px;
            }

            @include responsive('mdLandscape') {
                padding-top: $nav-height;
            }


            h1 {
                text-shadow: 1px 1px 1px rgb(0 0 0 / 20%);
                margin-bottom: 30px;

                &.small {
                    font-size: 30px;
                }
            }

            @include responsive("sm") {
                width: 100%;
                padding-top: 10px;

                h1 {
                    font-size: 25px;

                    &.small {
                        font-size: 25px;
                    }
                }
            }
        }
    }

    @include responsive('md') {
        overflow: auto;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        display: block;
    }

    @include responsive('sm') {
        height: calc(var(--vh100) - $nav-height); // allow for nav & footer popup
        overflow: auto;
        position: absolute;
        right: 0;
        top: $nav-height;
        bottom: 0;
        display: block;
        padding-bottom: 140px;
        padding-top: 0;
    }

    //-------//
    .tesla-bg {
        position: absolute;
        z-index: -1;
        top: 0px;

        &.bg-img {
            max-width: 100%;
        }
    }

    .overlay-colour {
        position: absolute;
        top: 0;
        z-index: 0;
        background: var(--primaryColour);
        opacity: 0.9;
        width: 100%;
        bottom: 0;
    }

    .help-topics {
        position: relative;
        padding-bottom: 10rem;

        @include responsive('md') {
            padding-bottom: 7rem;
        }

        @include responsive('mdLandscape') {
            padding-bottom: 5rem;
        }

        @include responsive('sm') {
            padding-bottom: 3rem;
        }
    }

    // button {
    //   background-color: var(--primaryColour);
    //   color: white;
    // }
}
</style>
